<template>
  <div class="modal modal-fullscreen modal-filter-details fade" id="modal-add-talent" role="dialog" aria-labelledby="shortlist-modal-label" aria-hidden="true">
    <div class="modal-dialog" data-backdrop="true" data-keyboard="true">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="shortlist-modal-label">
            <template v-if="$userIsAdmin">Add {{ $starLabelPlural }}</template>
            <template v-else-if="$userIsManager">{{ $t('Apply') }} For {{ $starLabelPlural }}</template>
          </h4>
        </div>
        <div class="modal-body">
          <talent-filtering scroll-target="#modal-add-talent .modal-body" :booking="this.booking" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-danger pull-left" data-dismiss="modal"><i class="fa fa-close"></i> Cancel</button>
          <ladda-button
            type="button"
            class="btn btn-lg btn-primary"
            :click="handleSaveAdditionalTalentCallback">
            <i class="fa fa-check"></i> Save
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { filter, find, findIndex } from 'lodash'
import LazyLoading from 'codium-lazy-loading'
import $ from 'jquery'
import TalentFiltering from '../../misc/TalentFiltering'
import { notify } from 'utils'

export default {
  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      talentToAdd: [],
      searching: false,
      search: {
        name: null
      }
    }
  },

  components: {
    TalentFiltering,
    LazyLoading
  },

  computed: {
    ...mapState('talent', ['talents']),
    ...mapState('filtering', ['selectedStars']),
    ...mapState('shortlist', ['shortlist']),

    tagNames () {
      return this.booking.tags.map(tag => tag.name).join(', ')
    },

    localShortlist: {
      get () {
        return this.shortlist
      },

      set (value) {
        this.setShortlist(value)
        this.storeShortlist()
      }
    },

    haveNoShortlistItems () {
      return this.localShortlist.length === 0
    },

    canShortlistItems () {
      return this.localShortlist.length < 10
    },

    /**
       * Determine if we are not searching.
       *
       * @return bool
       */
    notSearching () {
      return !this.searching
    },

    /**
       * Determine if we have search text.
       *
       * @return bool
       */
    haveSearchText () {
      return this.search.name !== null
    },

    /**
       * Determine if we have no talent without the existing talent.
       *
       * @return bool
       */
    haveNoTalentWithoutExisting () {
      return this.talentWithoutExisting.length === 0
    },

    /**
       * Filter out the existing talent against the booking from the search results.
       *
       * @return array
       */
    talentWithoutExisting () {
      return filter(this.talents, (talent) => {
        return find(this.booking.talent, (existing) => existing.id === talent.id) === undefined
      })
    }
  },

  mounted () {
    $(this.$el).on('hidden.bs.modal', () => {
      this.talentToAdd = []
      this.search.name = null
    })
  },

  beforeDestroy () {
    this.setSelectedStars([])
  },

  methods: {
    ...mapActions('filtering', ['setSelectedStars']),
    ...mapActions('shortlist', ['removeStar', 'setShortlist', 'storeShortlist', 'addStars']),

    /**
       * Determine if a talent already exists within the additional talent array.
       *
       * @return bool
       */
    talentIsAlreadyAdded (talent) {
      return find(this.talentToAdd, added => added.id === talent.id) !== undefined
    },

    /**
       * Handle adding talent to the array of additional talent.
       *
       * @return boolean
       */
    handleAddTalentCallback (talent, date) {
      talent.date_applied_for = date
      this.talentToAdd.push(talent)
      $('#dropdown-menu-' + talent.id).toggle()
    },

    /**
       * Handle removing talent from the array of additional talent.
       *
       * @return void
       */
    handleRemoveTalentCallback (talent) {
      talent.date_applied_for = null
      this.talentToAdd.splice(findIndex(this.talentToAdd, existing => existing.id === talent.id), 1)
      $('#dropdown-menu-' + talent.id).toggle()
    },

    /**
       * Handle clearing the search.
       *
       * @return void
       */
    handleClearSearchCallback () {
      this.search.name = null

      this.$refs.search.$el.click()
    },

    /**
       * Save the selected additional talent against the booking as hidden responses.
       *
       * @return Promise
       */
    async handleSaveAdditionalTalentCallback () {
      if (this.selectedStars.length === 0) {
        return Promise.resolve()
      } else {
        $('#modal-add-talent').modal('hide')
      }
      return this.addStars(this.selectedStars).then((response) => {
        this.setSelectedStars([])
        return response
      }).catch((error) => {
        notify.error(error.message)
      })
    }
  }
}
</script>
